import { useCallback, useEffect, useState } from "react";
import { FormatOptions } from "./FormatOptions";
import { getVbid } from "../../App/location";
import useLocalStorage from "../../storage/useLocalStorage";

const INITIAL_STATE = {
  [FormatOptions.FONT]: {
    enabled: false,
    value: "default",
  },
  [FormatOptions.TEXT]: {
    enabled: false,
    value: 1,
  },
  [FormatOptions.LINEHEIGHT]: {
    enabled: false,
    value: "",
  },
  [FormatOptions.MARGIN]: {
    enabled: false,
    value: "inherit",
  },
  [FormatOptions.MODE]: {
    enabled: false,
    value: "",
  },
};

const storageKey = `content-controls-${getVbid()}`;

export default function useOptionStorage() {
  const { set, get, remove } = useLocalStorage();
  const storedData = get(storageKey);

  const [readerOptions, setReaderOptions] = useState<
    Record<FormatOptions, { enabled: boolean; value: any }>
  >(storedData ? storedData.readerOptions : INITIAL_STATE);
  const [formattingOn, setFormatting] = useState(!!storedData);

  const resetOptions = useCallback(() => {
    setReaderOptions(INITIAL_STATE);
    setFormatting(false);
  }, []);

  useEffect(() => {
    if (formattingOn) {
      set(storageKey, { readerOptions, version: 1 });
    } else {
      remove(storageKey);
    }
  }, [formattingOn, readerOptions, set, remove]);

  return {
    readerOptions,
    setReaderOptions,
    formattingOn,
    setFormatting,
    resetOptions,
  };
}
